<script setup lang="ts">
import { hasVeeValidationErrorsForPaths } from '@/components/forms/utils';
import IndicatorLabel from '@/components/Tabs/IndicatorLabel.vue';
import { TabIndicatorState } from '@/components/Tabs/types.ts';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { computed, toRef } from 'vue';
import { useField, useFormErrors } from 'vee-validate';

const { name } = defineProps<{ name: string }>();

// Registers the row's path so its errors are not hoisted onto `combinationTable`; read-only.
const { errorMessage } = useField(
  toRef(() => name),
  undefined,
  { validateOnMount: false },
);

const formErrors = useFormErrors();

// Errors of the row's Track-it filters are shown at the filter fields; the row only flags them,
// like an evaluation scope flags errors of its parameters.
const hasTrackItFilterErrors = computed(() =>
  hasVeeValidationErrorsForPaths(formErrors.value, [`${name}.trackItFilters`]),
);
</script>

<template>
  <Tooltip v-if="errorMessage">
    <template #target="{ props: tooltipProps }">
      <IndicatorLabel v-bind="tooltipProps" :indicatorState="TabIndicatorState.ERROR" />
    </template>
    <template #tooltip>{{ errorMessage }}</template>
  </Tooltip>
  <IndicatorLabel v-else-if="hasTrackItFilterErrors" :indicatorState="TabIndicatorState.ERROR" />
</template>
